import { render } from "./PdfRelatorio.vue?vue&type=template&id=438b203c"
import script from "./PdfRelatorio.vue?vue&type=script&lang=js"
export * from "./PdfRelatorio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__